const API_BASE = process.env.NODE_ENV === 'development' ? 'http://localhost:8999' : ''

const getJumpPhotos = async () => {
    try {
        const response = await fetch(`${API_BASE}/get_jump_photos`)
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`)
        }
        const photos = await response.json()
        if (!Array.isArray(photos)) {
            return []
        }
        // Transform to match expected format
        // Uses /image/{id} endpoint for on-demand transformation
        return photos.map(photo => ({
            id: photo.id,
            title: photo.filename,
            // Build URL using the image transform endpoint
            // The endpoint returns a redirect to the public Tigris URL
            file: {
                url: `${API_BASE}/image/${photo.id}`
            },
            story: photo.story
        }))
    } catch (err) {
        console.error("Failed to fetch jump photos:", err)
        return []
    }
}

export default getJumpPhotos